var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.19995H2.6H15.4",
    stroke: "#95939F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 4.2V2.6C4.99998 2.17565 5.16855 1.76869 5.46861 1.46863C5.76866 1.16857 6.17563 1 6.59998 1H9.79998C10.2243 1 10.6313 1.16857 10.9313 1.46863C11.2314 1.76869 11.4 2.17565 11.4 2.6V4.2M13.8 4.2V15.4C13.8 15.8243 13.6314 16.2313 13.3313 16.5314C13.0313 16.8314 12.6243 17 12.2 17H4.19998C3.77563 17 3.36866 16.8314 3.0686 16.5314C2.76855 16.2313 2.59998 15.8243 2.59998 15.4V4.2H13.8Z",
    stroke: "#95939F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59998 8.19995V13",
    stroke: "#95939F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80005 8.19995V13",
    stroke: "#95939F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycle);
export default __webpack_public_path__ + "static/media/recycle.9bdac9f36ed1f78c7e356d9873b2f51e.svg";
export { ForwardRef as ReactComponent };